import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO_DATA = {
  // Ana Sayfa
  '/': {
    title: 'HizmetGeliyo - 2 Dakikada Güvenilir Usta Bul | Kombi, Klima, Beyaz Eşya Servisi',
    description: 'Yapay zeka destekli hizmet platformu. Kombi servisi, klima montajı, beyaz eşya tamiri, elektrikçi ve tesisatçı hizmetleri için hemen talep oluşturun. 7/24 hizmet, garantili işçilik.',
    keywords: 'usta bul, kombi servisi, klima servisi, beyaz eşya tamiri, elektrikçi, tesisatçı, ev hizmetleri, İstanbul usta',
    canonical: 'https://hizmetgeliyo.com'
  },
  
  // Hizmetler
  '/hizmetler': {
    title: 'Tüm Hizmetler | HizmetGeliyo - Kombi, Klima, Beyaz Eşya, Elektrik, Tesisat',
    description: 'HizmetGeliyo ile tüm ev hizmetlerine ulaşın. Kombi bakım ve arıza, klima montaj ve bakım, beyaz eşya tamiri, elektrik tesisatı ve su tesisatı hizmetleri.',
    keywords: 'ev hizmetleri, kombi bakım, klima montaj, beyaz eşya tamir, elektrikçi hizmetleri, tesisatçı hizmetleri',
    canonical: 'https://hizmetgeliyo.com/hizmetler'
  },
  
  // Hakkımızda
  '/hakkimizda': {
    title: 'Hakkımızda | HizmetGeliyo - Türkiye\'nin Güvenilir Hizmet Platformu',
    description: 'HizmetGeliyo, ev hizmetleri için Türkiye\'nin en güvenilir platformu. 2020\'den bu yana 100.000+ tamamlanmış iş, 500+ onaylı usta ve %100 müşteri memnuniyeti.',
    keywords: 'hizmetgeliyo hakkında, güvenilir usta platformu, ev hizmetleri şirketi, hizmetgeliyo tarihçesi',
    canonical: 'https://hizmetgeliyo.com/hakkimizda'
  },
  
  // İletişim
  '/iletisim': {
    title: 'İletişim | HizmetGeliyo - Bize Ulaşın | 0850 242 78 08',
    description: 'HizmetGeliyo müşteri hizmetleri ile 7/24 iletişime geçin. Telefon: 0850 242 78 08. Sorularınız, önerileriniz veya şikayetleriniz için destek ekibimiz yanınızda.',
    keywords: 'hizmetgeliyo iletişim, müşteri hizmetleri, destek hattı, 0850 242 78 08',
    canonical: 'https://hizmetgeliyo.com/iletisim'
  },
  
  // Nasıl Çalışır
  '/nasil-calisir': {
    title: 'Nasıl Çalışır? | HizmetGeliyo - 3 Adımda Usta Bul',
    description: 'HizmetGeliyo ile usta bulmak çok kolay! 1. Talep oluşturun 2. Teklif alın 3. Hizmeti alın. Yapay zeka ile en uygun ustayı size eşleştiriyoruz.',
    keywords: 'nasıl çalışır, usta bulma adımları, hizmet talebi oluşturma, yapay zeka eşleştirme',
    canonical: 'https://hizmetgeliyo.com/nasil-calisir'
  },
  
  // Müşteri Paneli
  '/hesabim': {
    title: 'Hesabım | HizmetGeliyo - Taleplerim ve Profilim',
    description: 'HizmetGeliyo hesabınızı yönetin. Aktif taleplerinizi takip edin, geçmiş hizmetlerinizi görüntüleyin ve profil bilgilerinizi güncelleyin.',
    keywords: 'hesabım, müşteri paneli, taleplerim, profil yönetimi',
    canonical: 'https://hizmetgeliyo.com/hesabim'
  },
  
  // Usta Ol / Kayıt
  '/usta-kayit': {
    title: 'Usta Kayıt | HizmetGeliyo - Ustalar İçin Yeni İş Fırsatları',
    description: 'HizmetGeliyo ailesine katılın! Kombi, klima, beyaz eşya, elektrik ve tesisat ustalarını arıyoruz. Yüksek kazanç, düzenli iş akışı. Hemen başvurun!',
    keywords: 'usta kayıt, usta ol, iş bul, kombi ustası, klima ustası, elektrikçi iş ilanı, tesisatçı iş ilanı',
    canonical: 'https://hizmetgeliyo.com/usta-kayit'
  },
  
  // Neden Bize Katıl
  '/neden-bize-katil': {
    title: 'Neden Bize Katılmalısınız? | HizmetGeliyo - Usta Avantajları',
    description: 'HizmetGeliyo ile çalışmanın avantajları: Düzenli iş akışı, güvenli ödeme, 7/24 destek, eğitim programları. Türkiye\'nin en büyük usta ağına katılın.',
    keywords: 'usta avantajları, hizmetgeliyo üyelik, usta kazanç, usta portal',
    canonical: 'https://hizmetgeliyo.com/neden-bize-katil'
  },
  
  // Garanti
  '/garanti': {
    title: 'Hizmet Garantisi | HizmetGeliyo - %100 Memnuniyet Garantisi',
    description: 'HizmetGeliyo ile tüm hizmetler garantili. Memnun kalmazsanız paranız iade. 1 yıla kadar işçilik garantisi ve 7/24 destek hattı.',
    keywords: 'hizmet garantisi, para iadesi, işçilik garantisi, memnuniyet garantisi',
    canonical: 'https://hizmetgeliyo.com/garanti'
  },
  
  // Garanti Şartları
  '/garanti-sartlari': {
    title: 'Garanti Şartları | HizmetGeliyo - Garanti Kapsamı ve Koşulları',
    description: 'HizmetGeliyo garanti şartları ve koşulları. Hangi durumlar garanti kapsamındadır? Garanti süreci nasıl işler? Detaylı bilgi için tıklayın.',
    keywords: 'garanti şartları, garanti koşulları, garanti kapsamı, garanti süreci',
    canonical: 'https://hizmetgeliyo.com/garanti-sartlari'
  },
  
  // Gizlilik Politikası
  '/gizlilik': {
    title: 'Gizlilik Politikası | HizmetGeliyo - KVKK Uyumlu',
    description: 'HizmetGeliyo gizlilik politikası ve KVKK aydınlatma metni. Kişisel verilerinizin güvenliği bizim için önemli. Verileriniz nasıl korunuyor?',
    keywords: 'gizlilik politikası, kişisel veri koruma, KVKK, veri güvenliği',
    canonical: 'https://hizmetgeliyo.com/gizlilik'
  },
  
  // Kullanım Koşulları
  '/kullanim-kosullari': {
    title: 'Kullanım Koşulları | HizmetGeliyo - Hizmet Şartları',
    description: 'HizmetGeliyo kullanım koşulları ve hizmet şartları. Platform kullanımı için geçerli kurallar ve sorumluluklar.',
    keywords: 'kullanım koşulları, hizmet şartları, platform kuralları',
    canonical: 'https://hizmetgeliyo.com/kullanim-kosullari'
  },
  
  // Bilgi Güvenliği
  '/bilgi-guvenligi': {
    title: 'Bilgi Güvenliği | HizmetGeliyo - Veri Koruma ve Güvenlik',
    description: 'HizmetGeliyo bilgi güvenliği politikası. SSL şifreleme, güvenli ödeme altyapısı ve veri koruma standartlarımız hakkında bilgi edinin.',
    keywords: 'bilgi güvenliği, veri koruma, SSL, güvenli ödeme, siber güvenlik',
    canonical: 'https://hizmetgeliyo.com/bilgi-guvenligi'
  },
  
  // Usta Portalı - Giriş
  '/prousta': {
    title: 'Usta Girişi | HizmetGeliyo - Usta Portalı',
    description: 'HizmetGeliyo usta portalına giriş yapın. İş taleplerinizi yönetin, kazançlarınızı takip edin ve müşterilerinizle iletişim kurun.',
    keywords: 'usta girişi, usta portal, usta paneli, iş yönetimi',
    canonical: 'https://hizmetgeliyo.com/prousta'
  },
  
  // Usta Portalı - Kayıt
  '/prousta/register': {
    title: 'Usta Kayıt | HizmetGeliyo - Yeni Usta Başvurusu',
    description: 'HizmetGeliyo usta ailesine katılın. Hızlı başvuru formu ile hemen kayıt olun ve yeni iş fırsatlarından yararlanın.',
    keywords: 'usta kayıt, usta başvuru, usta ol, iş başvurusu',
    canonical: 'https://hizmetgeliyo.com/prousta/register'
  },
  
  // Usta Portalı - Dashboard
  '/prousta/dashboard': {
    title: 'Usta Paneli | HizmetGeliyo - İş Yönetimi',
    description: 'HizmetGeliyo usta paneliniz. Aktif işlerinizi yönetin, yeni talepleri görün, kazançlarınızı takip edin.',
    keywords: 'usta paneli, iş yönetimi, usta dashboard, kazanç takibi',
    canonical: 'https://hizmetgeliyo.com/prousta/dashboard'
  },
  
  // Admin Giriş
  '/proadmin': {
    title: 'Admin Girişi | HizmetGeliyo Yönetim Paneli',
    description: 'HizmetGeliyo yönetim paneli girişi. Yetkili personel için.',
    keywords: 'admin girişi, yönetim paneli',
    canonical: 'https://hizmetgeliyo.com/proadmin'
  },
  
  // Admin Dashboard
  '/proadmin/dashboard': {
    title: 'Admin Panel | HizmetGeliyo Yönetim',
    description: 'HizmetGeliyo yönetim paneli. Platform yönetimi için.',
    keywords: 'admin panel, yönetim, dashboard',
    canonical: 'https://hizmetgeliyo.com/proadmin/dashboard'
  },
  
  // SSS - Sık Sorulan Sorular
  '/sss': {
    title: 'Sık Sorulan Sorular (SSS) | HizmetGeliyo - Kombi, Klima, Beyaz Eşya',
    description: 'Kombi bakımı, klima montajı, beyaz eşya tamiri, elektrik ve tesisat hizmetleri hakkında sık sorulan sorular ve cevapları. Arıza çözümleri, fiyat bilgileri ve uzman tavsiyeleri.',
    keywords: 'sık sorulan sorular, kombi bakımı, klima montajı, beyaz eşya tamiri, elektrikçi, tesisatçı, arıza çözümleri, fiyat bilgisi, ev hizmetleri SSS',
    canonical: 'https://hizmetgeliyo.com/sss'
  }
};

// Dynamic SEO for service request pages
const getServiceSEO = (category) => {
  const services = {
    'kombi': {
      title: 'Kombi Servisi Talebi | HizmetGeliyo - Kombi Bakım, Arıza, Montaj',
      description: 'Kombi servisi için hemen talep oluşturun. Kombi bakım, kombi arıza, kombi montaj ve demontaj hizmetleri. Tüm markalar için garantili işçilik, uygun fiyat.',
      keywords: 'kombi servisi, kombi bakım, kombi arıza, kombi tamiri, kombi montaj, kombi ustası',
      canonical: 'https://hizmetgeliyo.com/talep/kombi'
    },
    'klima': {
      title: 'Klima Servisi Talebi | HizmetGeliyo - Klima Montaj, Bakım, Arıza',
      description: 'Klima servisi için hemen talep oluşturun. Klima montaj, klima bakım, klima arıza ve gaz dolumu hizmetleri. Tüm markalar için profesyonel hizmet.',
      keywords: 'klima servisi, klima montaj, klima bakım, klima arıza, klima gaz dolumu, klima ustası',
      canonical: 'https://hizmetgeliyo.com/talep/klima'
    },
    'beyaz_esya': {
      title: 'Beyaz Eşya Tamiri Talebi | HizmetGeliyo - Buzdolabı, Çamaşır, Bulaşık Makinesi',
      description: 'Beyaz eşya tamiri için hemen talep oluşturun. Buzdolabı, çamaşır makinesi, bulaşık makinesi, kurutma makinesi tamiri. Orijinal yedek parça garantisi.',
      keywords: 'beyaz eşya tamiri, buzdolabı tamiri, çamaşır makinesi tamiri, bulaşık makinesi tamiri, beyaz eşya ustası',
      canonical: 'https://hizmetgeliyo.com/talep/beyaz_esya'
    },
    'elektrik': {
      title: 'Elektrikçi Talebi | HizmetGeliyo - Elektrik Arıza, Tesisat, Montaj',
      description: 'Elektrikçi hizmeti için hemen talep oluşturun. Elektrik arıza, elektrik tesisat, priz montaj, aydınlatma, sigorta değişimi hizmetleri.',
      keywords: 'elektrikçi, elektrik arıza, elektrik tesisat, priz montaj, aydınlatma, sigorta',
      canonical: 'https://hizmetgeliyo.com/talep/elektrik'
    },
    'su_tesisati': {
      title: 'Tesisatçı Talebi | HizmetGeliyo - Su Tesisatı, Tıkanıklık, Sızıntı',
      description: 'Tesisatçı hizmeti için hemen talep oluşturun. Su tesisatı, tıkanıklık açma, sızıntı tamiri, musluk montaj, banyo renovasyonu hizmetleri.',
      keywords: 'tesisatçı, su tesisatı, tıkanıklık açma, sızıntı tamiri, musluk montaj, boru tamiri',
      canonical: 'https://hizmetgeliyo.com/talep/su_tesisati'
    },
    'petek': {
      title: 'Petek Temizliği Talebi | HizmetGeliyo - Petek Bakım ve Temizlik',
      description: 'Petek temizliği için hemen talep oluşturun. Profesyonel petek temizleme, petek bakım, kalorifer sistemi bakımı hizmetleri.',
      keywords: 'petek temizliği, petek bakım, kalorifer bakımı, petek temizleme, ısıtma sistemi bakımı',
      canonical: 'https://hizmetgeliyo.com/talep/petek'
    },
    'genel': {
      title: 'Genel Hizmet Talebi | HizmetGeliyo - Diğer Ev Hizmetleri',
      description: 'Ev hizmetleri için hemen talep oluşturun. Kategorilerde bulamadığınız özel hizmet talepleriniz için buradan başvurun.',
      keywords: 'ev hizmetleri, genel hizmet, özel talep, usta bul',
      canonical: 'https://hizmetgeliyo.com/talep/genel'
    }
  };
  
  return services[category] || {
    title: 'Hizmet Talebi Oluştur | HizmetGeliyo - Güvenilir Usta Bul',
    description: 'Ev hizmetleri için hemen talep oluşturun. Kombi, klima, beyaz eşya, elektrik ve tesisat hizmetleri. Güvenilir ustalar, garantili işçilik.',
    keywords: 'hizmet talebi, usta bul, ev hizmetleri, servis talebi',
    canonical: 'https://hizmetgeliyo.com/talep'
  };
};

const SEOHead = () => {
  const location = useLocation();
  
  useEffect(() => {
    let seoData;
    
    // Check for service request pages
    if (location.pathname.startsWith('/talep/') || location.pathname.startsWith('/servis-talep/')) {
      const category = location.pathname.split('/').pop();
      seoData = getServiceSEO(category);
    } else {
      seoData = SEO_DATA[location.pathname] || {
        title: 'HizmetGeliyo - Güvenilir Ev Hizmetleri Platformu',
        description: 'Kombi, klima, beyaz eşya, elektrik ve tesisat hizmetleri için güvenilir ustalar. Yapay zeka destekli eşleştirme, garantili işçilik.',
        keywords: 'ev hizmetleri, usta bul, kombi servisi, klima servisi',
        canonical: `https://hizmetgeliyo.com${location.pathname}`
      };
    }
    
    // Update document title
    document.title = seoData.title;
    
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = seoData.description;
    
    // Update or create meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.name = 'keywords';
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.content = seoData.keywords;
    
    // Update or create canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = seoData.canonical || `https://hizmetgeliyo.com${location.pathname}`;
    
    // Open Graph tags
    const updateOGTag = (property, content) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    };
    
    updateOGTag('og:title', seoData.title);
    updateOGTag('og:description', seoData.description);
    updateOGTag('og:url', seoData.canonical || `https://hizmetgeliyo.com${location.pathname}`);
    updateOGTag('og:type', 'website');
    updateOGTag('og:site_name', 'HizmetGeliyo');
    updateOGTag('og:locale', 'tr_TR');
    updateOGTag('og:image', 'https://hizmetgeliyo.com/og-image.jpg');
    
    // Twitter Card tags
    const updateTwitterTag = (name, content) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.name = name;
        document.head.appendChild(tag);
      }
      tag.content = content;
    };
    
    updateTwitterTag('twitter:card', 'summary_large_image');
    updateTwitterTag('twitter:title', seoData.title);
    updateTwitterTag('twitter:description', seoData.description);
    updateTwitterTag('twitter:image', 'https://hizmetgeliyo.com/og-image.jpg');
    
    // Structured Data (JSON-LD) - Advanced Schema.org Implementation
    // Remove old structured data scripts
    document.querySelectorAll('script[type="application/ld+json"][data-seo-head="true"]').forEach(el => el.remove());
    
    // 1. Organization Schema (Site-wide)
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "@id": "https://hizmetgeliyo.com/#organization",
      "name": "HizmetGeliyo",
      "alternateName": "Hizmet Geliyo",
      "url": "https://hizmetgeliyo.com",
      "logo": {
        "@type": "ImageObject",
        "url": "https://hizmetgeliyo.com/logo.webp",
        "width": 200,
        "height": 60
      },
      "description": "Türkiye'nin en güvenilir ev hizmetleri platformu. Kombi, klima, beyaz eşya, elektrik ve tesisat hizmetleri.",
      "foundingDate": "2020",
      "telephone": "+908502427808",
      "email": "info@hizmetgeliyo.com",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "TR",
        "addressLocality": "Türkiye"
      },
      "sameAs": [
        "https://www.instagram.com/hizmetgeliyo/",
        "https://www.youtube.com/@hizmetgeliyo",
        "https://www.facebook.com/profile.php?id=61586891289286"
      ],
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+908502427808",
          "contactType": "customer service",
          "availableLanguage": "Turkish",
          "areaServed": "TR"
        }
      ]
    };

    // 2. WebSite Schema with SearchAction
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": "https://hizmetgeliyo.com/#website",
      "name": "HizmetGeliyo",
      "url": "https://hizmetgeliyo.com",
      "publisher": { "@id": "https://hizmetgeliyo.com/#organization" },
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": "https://hizmetgeliyo.com/hizmetler?q={search_term_string}"
        },
        "query-input": "required name=search_term_string"
      }
    };

    // 3. LocalBusiness Schema
    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "HomeAndConstructionBusiness",
      "@id": "https://hizmetgeliyo.com/#localbusiness",
      "name": "HizmetGeliyo",
      "image": "https://hizmetgeliyo.com/logo.webp",
      "description": "Profesyonel ev hizmetleri: Kombi servisi, klima servisi, beyaz eşya tamiri, elektrik ve tesisat işleri.",
      "url": "https://hizmetgeliyo.com",
      "telephone": "+908502427808",
      "priceRange": "₺₺",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "TR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 39.9334,
        "longitude": 32.8597
      },
      "areaServed": [
        { "@type": "Country", "name": "Türkiye" },
        { "@type": "City", "name": "İstanbul" },
        { "@type": "City", "name": "Ankara" },
        { "@type": "City", "name": "İzmir" },
        { "@type": "City", "name": "Bursa" },
        { "@type": "City", "name": "Antalya" }
      ],
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        "opens": "00:00",
        "closes": "23:59"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "bestRating": "5",
        "worstRating": "1",
        "reviewCount": "12847",
        "ratingCount": "12847"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Ev Hizmetleri",
        "itemListElement": [
          {
            "@type": "OfferCatalog",
            "name": "Kombi Hizmetleri",
            "itemListElement": [
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Kombi Arıza Servisi" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Kombi Bakım" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Kombi Montaj" } }
            ]
          },
          {
            "@type": "OfferCatalog",
            "name": "Klima Hizmetleri",
            "itemListElement": [
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Klima Montaj" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Klima Bakım" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Klima Arıza" } }
            ]
          },
          {
            "@type": "OfferCatalog",
            "name": "Beyaz Eşya Hizmetleri",
            "itemListElement": [
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Çamaşır Makinesi Tamiri" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Bulaşık Makinesi Tamiri" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Buzdolabı Tamiri" } }
            ]
          },
          {
            "@type": "OfferCatalog",
            "name": "Elektrik Hizmetleri",
            "itemListElement": [
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Elektrik Arıza" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Elektrik Tesisatı" } }
            ]
          },
          {
            "@type": "OfferCatalog",
            "name": "Tesisat Hizmetleri",
            "itemListElement": [
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Su Tesisatı" } },
              { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Pis Su Giderimi" } }
            ]
          }
        ]
      }
    };

    // 4. BreadcrumbList Schema (dynamic based on path)
    const pathParts = location.pathname.split('/').filter(Boolean);
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Ana Sayfa",
          "item": "https://hizmetgeliyo.com"
        },
        ...pathParts.map((part, index) => ({
          "@type": "ListItem",
          "position": index + 2,
          "name": getBreadcrumbName(part),
          "item": `https://hizmetgeliyo.com/${pathParts.slice(0, index + 1).join('/')}`
        }))
      ]
    };

    // 5. FAQ Schema for main pages
    const faqSchema = location.pathname === '/' || location.pathname === '/hizmetler' ? {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "HizmetGeliyo nedir?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "HizmetGeliyo, Türkiye'nin lider ev hizmetleri platformudur. Kombi, klima, beyaz eşya, elektrik ve tesisat gibi alanlarda güvenilir ustaları müşterilerle buluşturur."
          }
        },
        {
          "@type": "Question",
          "name": "Usta ne kadar sürede gelir?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Acil durumlarda 1-2 saat içinde, randevulu işlemlerde aynı gün içinde ustamız adresinize gelir. 7/24 hizmet sunuyoruz."
          }
        },
        {
          "@type": "Question",
          "name": "Hizmet garantisi var mı?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Evet, tüm hizmetlerimiz garantilidir. Memnun kalmazsanız ücretsiz tekrar hizmet veya para iadesi sağlıyoruz."
          }
        },
        {
          "@type": "Question",
          "name": "Hangi şehirlerde hizmet veriyorsunuz?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Türkiye genelinde 81 ilde hizmet veriyoruz. Özellikle İstanbul, Ankara, İzmir, Bursa ve Antalya'da yoğun usta ağımız bulunmaktadır."
          }
        },
        {
          "@type": "Question",
          "name": "Ödeme nasıl yapılır?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Nakit, kredi kartı ve havale/EFT ile ödeme yapabilirsiniz. İş tamamlandıktan sonra usta'ya ödeme yaparsınız."
          }
        }
      ]
    } : null;

    // Helper function for breadcrumb names
    function getBreadcrumbName(slug) {
      const names = {
        'hizmetler': 'Hizmetler',
        'hakkimizda': 'Hakkımızda',
        'iletisim': 'İletişim',
        'nasil-calisir': 'Nasıl Çalışır',
        'hesabim': 'Hesabım',
        'usta-kayit': 'Usta Kayıt',
        'blog': 'Blog',
        'talep': 'Talep Oluştur',
        'kombi-servisi': 'Kombi Servisi',
        'klima-servisi': 'Klima Servisi',
        'beyaz-esya-servisi': 'Beyaz Eşya Servisi',
        'elektrik-servisi': 'Elektrik Servisi',
        'ankara-kombi-servisi': 'Ankara Kombi Servisi',
        'istanbul-kombi-servisi': 'İstanbul Kombi Servisi',
        'izmir-kombi-servisi': 'İzmir Kombi Servisi',
        'garanti': 'Garanti',
        'garanti-sartlari': 'Garanti Şartları',
        'kvkk': 'KVKK',
        'gizlilik-politikasi': 'Gizlilik Politikası',
        'kullanim-kosullari': 'Kullanım Koşulları'
      };
      return names[slug] || slug.charAt(0).toUpperCase() + slug.slice(1).replace(/-/g, ' ');
    }

    // Add all schemas to head
    const addSchema = (schema, id) => {
      if (!schema) return;
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo-head', 'true');
      script.setAttribute('data-schema-id', id);
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    };

    addSchema(organizationSchema, 'organization');
    addSchema(websiteSchema, 'website');
    addSchema(localBusinessSchema, 'localbusiness');
    if (pathParts.length > 0) {
      addSchema(breadcrumbSchema, 'breadcrumb');
    }
    if (faqSchema) {
      addSchema(faqSchema, 'faq');
    }
    
  }, [location.pathname]);
  
  return null;
};

export default SEOHead;
